export { default, createFilterOptions } from './Autocomplete';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Autocomplete/index.js
// module id = 171
// module chunks = 0